import { Route, Routes, BrowserRouter } from 'react-router-dom';
import Landing from './screens/LandingScreen/LandingScreen';
import UIComponentsScreen from './screens/UIComponentsScreen/UIComponentsScreen';
import HomeScreen from './screens/HomeScreen/HomeScreen';
import CreateIncubationScreen from './screens/CreateIncubationScreen/CreateIncubationScreen';
import IncubationScreen from './screens/IncubationScreen/IncubationScreen';
import AddUserScreen from './screens/AddUserScreen/AddUserScreen';
import AddOrganizationScreen from './screens/AddOrganizationScreen/AddOrganizationScreen';
import SettingsScreen from './screens/SettingsScreen/SettingsScreen';
import AddParticipantsScreen from './screens/AddParticipantsScreen/AddParticipantsScreen';
import AddParticipantsCsvScreen from './screens/AddParticipantsCsvScreen/AddParticipantsCsvScreen';
import WebhookInstructionsScreen from './screens/WebhookInstructionsScreen/WebhookInstructionsScreen';
import SurveysScreen from './screens/SurveysScreen/SurveysScreen';
import IncubationLogsScreen from './screens/IncubationLogsScreen/IncubationLogsScreen';
import VersionReviewScreen from './screens/VersionReviewScreen/VersionReviewScreen';
import PetDetailsScreen from './screens/PetDetailsScreen/PetDetailsScreen';
import ParticipantDetailsScreen from './screens/ParticipantDetailsScreen/ParticipantDetailsScreen';
import ParentDetailsScreen from './screens/ParentDetailsScreen/ParentDetailsScreen';
import { ToastProvider } from './contexts/ToastContext';
import { UserProvider } from './contexts/UserContext';
import Toast from './components/ui/Toast/Toast';
import './App.css';

export default function App() {
  return (
    <ToastProvider>
      <UserProvider>
        <BrowserRouter>
        <div className="app-content">
          <div className="main-content">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/ui" element={<UIComponentsScreen />} />
              <Route path="/home" element={<HomeScreen />} />
              <Route path="/create-incubation" element={<CreateIncubationScreen />} />
              <Route path="/edit-incubation" element={<CreateIncubationScreen />} />
              <Route path="/incubation" element={<IncubationScreen />} />
              <Route path="/add-user" element={<AddUserScreen />} />
              <Route path="/edit-user/:id" element={<AddUserScreen />} />
              <Route path="/add-organization" element={<AddOrganizationScreen />} />
              <Route path="/edit-organization/:id" element={<AddOrganizationScreen />} />
              <Route path="/settings" element={<SettingsScreen />} />
              <Route path="/add-participants" element={<AddParticipantsScreen />} />
              <Route path="/add-participants-csv" element={<AddParticipantsCsvScreen />} />
              <Route path="/webhook-instructions" element={<WebhookInstructionsScreen />} />
              <Route path="/incubation-surveys" element={<SurveysScreen />} />
              <Route path="/incubation-logs" element={<IncubationLogsScreen />} />
              <Route path="/version-review" element={<VersionReviewScreen />} />
              <Route path="/pet-details/:pet_id" element={<PetDetailsScreen />} />
              <Route path="/participant-details/:pet_incubation_id" element={<ParticipantDetailsScreen />} />
              <Route path="/parent-details" element={<ParentDetailsScreen />} />
            </Routes>
          </div>
        </div>
        <Toast />
        </BrowserRouter>
      </UserProvider>
    </ToastProvider>
  );
}
